// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## ExtraProductRule Get
/**
 *
 * @param {{params: object, query: { productCategoryId: string,  "productId": string, "customerId": string, isYearCustomer: boolean, page: number, limit: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.ExtraProductRule.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## ExtraProductRule Create
/**
 *
 * @param {{"productCount": number,"productUnit": "Price","extraProductCount": number,"extraProductUnit": "Price","description": "string","customerId": "string","isYearCustomer": true,"dayBalance": {"day": number,"balance": number},"ruleType": "Product","ruleValidationDay": number}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.ExtraProductRule.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ExtraProduct Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.ExtraProductRule.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ExtraProduct Update
/**
 *
 * @param {{"productCount": number,"productUnit": "Price","extraProductCount": number,"extraProductUnit": "Price","description": "string","customerId": "string","isYearCustomer": true,"dayBalance": {"day": number,"balance": number},"ruleType": "Product","ruleValidationDay": number}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.ExtraProductRule.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ExtraProduct Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.ExtraProductRule.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ExtraProductRule GetValidProductRules (müşteriye uygun kampanya kuralları)
/**
 * @param {{ params?: object, query: { customerId: string } }} option
 */
export const GetValidProductRules = async (option) => {
  const response = await $api.get(
    Endpoints.ExtraProductRule.GetValidProductRules(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  GetValidProductRules,
};
